export const translations = {
  'ko-KR': {
    translation: {
      addUser: '사용자 추가',
      editUser: '사용자 편집',
      firstName: '이름',
      lastName: '성',
      name: '이름',
      role: '역할',
      status: '상태',
      email: '이메일',
      phone: '전화',
      type: '유형',
      details: '세부 정보',
      nodes: '노드',
      roles: '역할',
      cancel: '취소',
      submit: '제출',
      delete: '삭제',
      create: '생성',
      deleteNodeError: '노드 삭제 오류',
      deleteConfirmation: '삭제하시겠습니까?',
      warning: '경고',
      Alert: '경보',
      deleteSure: '예, 확실합니다.',
      nodesWillBeCreatedAt: '다음에서 노드가 생성됩니다.',
      searchFor: '검색 조건',
      rolesError: '역할을 가져오는 중 오류 발생',
      userListError: '사용자 목록을 가져오는 중 오류 발생',
      organisationListError: '조직 목록을 가져오는 중 오류 발생',
      loadingRoles: '역할 로드 중...',
      selectRole: '역할 선택',
      validEmail: '유효한 이메일 주소를 입력하십시오',
      requiredEmail: '이메일이 필요합니다',
      resend: '다시 보내기',
      restrictedDomain: '제한된 이메일 도메인',
      addUserSuccess: '사용자가 성공적으로 추가되었습니다',
      editUserSuccess: '사용자가 성공적으로 편집됨',
      deleteUserSuccess: '사용자가 성공적으로 삭제되었습니다',
      deleteModalAlertMessage:
        '사용자 {{userName}}을(를) 삭제하려고 합니다. 사용자에 대한 모든 권한이 취소됩니다.',
      deleteProceedMessage: '삭제를 진행하시겠습니까?',
      userAlreadyExist: '이 이메일 ID를 가진 사용자가 이미 존재합니다.',
      addUserError: '사용자를 추가할 수 없습니다. 다시 시도하십시오.',
      editUserError: '사용자를 편집할 수 없습니다. 다시 시도하십시오.',
      deleteUserError: '사용자를 삭제할 수 없습니다. 다시 시도하십시오.',
      nodesError: '할당된 노드를 가져오는 중 오류가 발생했습니다',
      childNodesError: '계층 수준 로드 오류',
      hierarchyError: '계층 구조를 가져오는 중 오류 발생',
      requestFailed: '요청 실패',
      emailSentSuccess: '활성화 이메일이 성공적으로 전송되었습니다!',
      activationEmailError: '활성화 이메일을 보내지 못했습니다.',
      activationEmailError1:
        '활성화 이메일을 보내지 못했습니다. 나중에 다시 시도하세요.',
      allOrganisations: '모든 조직',
      address: '주소',
      hierarchyMetaError: '계층 구조 세부 정보를 가져오는 중 오류 발생',
      nodeMetaError: '노드 세부 정보를 로드하는 중 오류 발생',
      contactName: '연락처 이름',
      downloadTemplate: '템플릿 다운로드',
      newOrg: '새 조직',
      save: '저장',
      upload: '업로드',
      uploading: '업로드 중',
      dropExcel: 'Excel 시트를 놓거나',
      browse: '찾아보기',
      importSettings: '설정 가져오기',
      addNodesSites: '새 노드/사이트 추가',
      updateNodesSites: '기존 노드/사이트에 대한 정보 업데이트',
      disableNodesSites: '더 이상 존재하지 않는 노드/사이트 비활성화',
      disabled: '비활성화됨',
      new: '신규',
      updated: '업데이트됨',
      siteInstallation: '사이트',
      addOrgSuccess: '조직이 성공적으로 만들어졌습니다!',
      excelUploadError: '엑셀을 저장하지 못했습니다. 다시 시도하세요.',
      saveError: '저장에 실패했습니다. 나중에 다시 시도하십시오.',
      saveBadRequestError:
        '저장에 실패했습니다. 저장하려는 데이터에 문제가 있을 수 있습니다.',
      telephone: '전화',
      externalIds: '외부 ID',
      contactEmail: '연락처 이메일',
      longitude: '경도',
      latitude: '위도',
      primaryContactName: '기본 연락처 이름',
      primaryContactEmail: '주요 연락처 이메일',
      templateError:
        '템플릿을 다운로드하는 동안 오류가 발생했습니다. 나중에 다시 시도하십시오.',
      templateError1: '템플릿을 얻을 수 없습니다. 나중에 다시 시도하십시오.',
      home: '홈',
      organisations: '조직',
      users: '사용자',
      lightTheme: '라이트 테마',
      darkTheme: '어두운 테마',
      login: '로그인',
      logout: '로그아웃',
      activateUserAcc: '사용자 계정 활성화',
      phoneNumber: '전화번호',
      optional: '선택 사항',
      password: '비밀번호',
      confirmPassword: '비밀번호 확인',
      endUser: '최종 사용자 사용권 계약',
      iAccept: '최종 사용자 사용권 계약에 동의합니다.',
      iHereby: '이로써 다음을 읽고 수락했음을 확인합니다.',
      eula: '최종 사용자 사용권 계약',
      iRead: 'Honeywell 개인 정보 보호 정책을 읽었습니다.',
      iUnderstood: '예, 다음을 읽고 이해했습니다.',
      privacyPolicy: '개인정보 보호정책',
      activate: '활성화',
      activationSuccess: '활성화 성공',
      newAccAccess:
        '새 계정에 액세스하려면 새 사용자 이름을 사용하여 로그인하십시오. 이 새 사용자 이름은 아래에 표시되어 있습니다.',
      emailSent: '새 사용자 이름이 이메일 ID로 전송되었습니다.',
      signin: '로그인',
      activationError: '활성화 실패',
      pleaseTryAgain: '다시 시도하십시오',
      activationExpired: '활성화 토큰이 만료되었습니다',
      activationExpiredText:
        '이메일 링크가 시간 초과되었거나, 이미 사용되었거나, 올바르지 않았기 때문일 수 있습니다. 문제가 지속되면 새 활성화 이메일을 요청하십시오.',
      contactSupport: '오류. 지원팀에 문의하세요',
      pwdMatch: '비밀번호는 일치해야 합니다',
      required: '필수',
      eligiblePwd:
        '비밀번호는 최소 1개의 대문자, 1개의 소문자, 1개의 숫자, 1개의 특수 문자 및 최소 11개의 문자를 포함해야 합니다.',
      invalidPhoneNumber: '전화번호가 유효하지 않습니다',
      invalidName:
        '이름은 선행 또는 후행 공백 없이 255자를 초과할 수 없습니다.',
      invalidFirstName: 'FirstName에 잘못된 문자가 포함되어 있습니다.',
      invalidLastName: 'LastName에 잘못된 문자가 포함되어 있습니다.',
      timezone: '시간대',
      timeZone: '시간대',
      commissioningStatus: '시운전 상태',
      countryCode: '국가 코드',
      childCount: '자식 수',
      sheetVersion: '시트 버전',
      unknownError: '알 수 없는 오류입니다. 나중에 다시 시도하십시오.',
      preview: '미리보기',
      file: '파일',
      inCompatibleExcel: '파일은 .xlsx 형식이어야 합니다.',
      selectOrg: '조직 선택',
      noRecordFound: '레코드 없음',
      total: '총합',
      items: '항목',
      forbidden: '금지됨',
      noPermissionText: '이 페이지에 액세스할 권한이 없습니다.',
      accessPermission: '액세스 권한이 있는 계정에 로그인하십시오',
      technicianExternalAccessPermission:
        '모바일 애플리케이션에 로그인해 주세요',
      redirectToLogin: '로그인 페이지로 리디렉션 중',
      errorUserSettings: '사용자 설정을 가져오는 중 오류 발생',
      invalidSystemGuid: '잘못된 시스템 GUID',
      languageNotSupported: '지원되지 않는 언어',
      subscriptions: '구독',
      gatewayManagement: '게이트웨이 관리',
      subscriptionNumber: '구독 번호',
      orderNumber: '주문 번호',
      bundle: '번들',
      activatedOn: '활성화 날짜',
      order: '순서',
      editSubscription: '구독 편집',
      noNodeSelected: '선택한 노드가 없습니다.',
      noUserSelected: '선택한 사용자 없음',
      loadingBundles: '번들 로드 중...',
      bundlesError: '번들을 가져오는 중 오류 발생',
      selectBundle: '번들 선택',
      addSubscriptionSuccess: '구독이 성공적으로 추가되었습니다',
      addSubscriptionError: '구독을 추가할 수 없습니다. 다시 시도하세요.',
      subscriptionInputValidationError:
        '영숫자 값과 하이픈을 사용할 수 있으며 13자를 초과해서는 안 됩니다.',
      errorUserGlobalPrivileges: '사용자 전역 권한을 가져오는 중 오류 발생',
      subscriptionAlreadyExist: '구독이 이미 존재합니다.',
      invalidSubscription: '잘못된 구독',
      Version: '버전',
      systemType: '시스템 유형',
      systemId: '시스템 ID',
      reviewGatewayDetails: '게이트웨이 세부 정보 검토',
      site: '사이트',
      Organisation: '조직',
      gatewayRegistration: '게이트웨이 등록',
      selectAnOrg: '조직 선택',
      selectASite: '사이트 선택',
      register: '등록',
      selectSiteToRegsiter: '게이트웨이를 등록할 사이트 선택',
      gatewayRegistrationFailureMsg:
        'Honeywell Sentience IOT 플랫폼에 게이트웨이를 등록하지 못했습니다.',
      gatewayRegistrationSuccessMsg:
        '게이트웨이가 Honeywell Sentience IOT 플랫폼에 성공적으로 등록되었습니다.',
      siteEmptyMsg:
        '{{- orgName}} 조직의 모든 사이트가 이미 등록되어 있습니다.',
      forgeOnboarding: '조직 매핑',
      SiteFetchingFailure: 'Forge에서 사이트를 가져오지 못했습니다.',
      selectAllSitesText: '원격 빌딩 관리자에 온보딩할 모든 Forge 사이트 선택',
      onBoardingFailure: '사이트 온보딩을 시작하지 못했습니다.',
      customerID: '고객 ID',
      enterCustomerID: '고객 ID 입력',
      loadingSites: '사이트 로드 중...',
      fetchSites: '사이트 가져오기',
      subscriptionActivateSuccess:
        '"{{siteName}}"에 대한 구독이 성공적으로 활성화되었습니다.',
      subscriptionActivateError:
        '기술적인 문제로 인해 활성화할 수 없습니다. 관리자에게 문의하십시오.',
      activateNow: '지금 활성화',
      multiSiteSuccess: '사이트가 성공적으로 추가되었습니다.',
      onboardSelected: '선택한 항목 온보딩',
      sitePartialSuccess:
        '기술적인 문제로 인해 일부 사이트를 온보딩하지 못했습니다. 다시 시도하거나 관리자에게 문의하십시오.',
      confirm: '확인',
      onboardingFailed: '온보딩 실패',
      failed: '실패',
      onboardedSuccessfully: '사이트 온보딩됨',
      notOnboarded: '온보딩되지 않음',
      onboarding: '온보딩...',
      reOnboard: '재온보딩',
      selectAll: '모두 선택',
      siteSuccess: '사이트가 성공적으로 추가되었습니다.',
      dataloseWarning:
        '사이트가 온보딩되는 동안 페이지를 새로 고치지 마십시오.',
      addServiceSuccess: '서비스가 성공적으로 추가되었습니다',
      addServicesText: '서비스 추가',
      validityText: '유효 기간',
      invalidInputError: '잘못된 입력',
      subsactivateError: '구독이 이미 활성화되었습니다',
      subsnotfoundError: '구독 세부 정보 없음',
      invalidorderError: '잘못된 주문 번호',
      bundnotfoundError: '번들 세부 정보를 찾을 수 없습니다',
      subscribedServices: '가입 서비스',
      subsactivateSuccess: '구독이 생성되고 성공적으로 활성화되었습니다.',
      subsactivateFailure:
        '구독이 생성되었지만 활성화하지 못했습니다. 다시 시도하십시오.',
      subsactivateDiffSite: '다른 사이트에 대해 이미 활성화된 구독',
      gatewayAssociation: '게이트웨이 연결',
      systemGuid: '시스템 GUID',
      success: '성공',
      contactSystemAdministrator: '시스템 관리자에게 문의하십시오',
      siteName: '사이트 이름',
      location: '위치',
      action: '동작',
      addNewSite: '새 사이트 추가',
      add: '추가',
      sitesAssociated: '{{siteCount}}개 사이트 연결됨',
      numberOfAddon: '애드온 수',
      searchSite: '사이트 검색',
      noResultFound: '검색된 결과 없음',
      noDataFound: '데이터를 찾을 수 없습니다',
      loadMore: '더 로드하기',
      unlinkMessage:
        '{{sku}}에서 {{siteName}}의 바인딩을 해제하려면 Honeywell 고객 관리 센터 (+01 480-353-3020)에 문의하거나 support@honeywell.com로 이메일을 보내십시오',
      associatedOrderNumber: '관련 주문 번호',
      associatedSubscriptionNumber: '관련 구독 번호',
      helperTextSKU: '구독 번호를 수정하려면 다음으로 문의하십시오.',
      helperOrderTextSKU: '주문 번호를 수정하려면 다음으로 문의하십시오.',
      customerCare: '고객 관리',
      skuDetails: 'SKU 세부 정보',
      manageSites: '사이트 관리',
      skuName: 'SKU 이름',
      skuDescription: 'SKU 설명',
      licenseUtilization: '라이센스 이용률',
      validTill: '유효 기간',
      editSKU: 'SKU 편집',
      duplicateSiteError: '사이트가 이미 추가되었습니다',
      numberOfAddonRequired: '애드온 수를 입력하십시오',
      siteFetchError: '사이트 목록을 가져오는 중 오류 발생',
      siteSuccessMsg: '사이트가 성공적으로 추가됨',
      siteFailedMsg: '사이트를 추가하지 못했습니다',
      problemWithRequest: '요청에 문제가 있었습니다.',
      newSubscriptionAdded: '새 구독 추가됨',
      licensesOf: '다음의 라이센스',
      all: '모두',
      orderPlacedBy: '주문자',
      pendingRenewal: '갱신 보류 중',
      daysRemaining: '남은 일수',
      renewSubscriptionMessage:
        '{{skuName}}을 갱신하려면 Honeywell 고객 관리 센터 (+01 480-353-3020)에 문의하거나 support@honeywell.com로 이메일을 보내십시오',
      columnSelection: '열 선택',
      selectUpTo: '최대로 다음을 선택할 수 있습니다.',
      itemsToDisplay: '테이블에 표시할 항목입니다.',
      subscriptionManagement: '구독 관리',
      activated: '활성화됨',
      warningHeader: '꼭 취소하시겠습니까?',
      warningMessage: '손실될 수 있는 저장되지 않은 변경 사항이 있습니다',
      renewSubscription: '구독 갱신',
      pendingActivation: '활성화 보류 중',
      notAuthorizedError: '이 조직에 SKU를 할당할 권한이 없습니다.',
      gatewayRegistrationInProgress: '{{gateway}} 진행 중',
      gatewayAssociationFailed:
        '게이트웨이 연결을 확인하고 다시 시도하십시오. 다시 실패하면 시스템 관리자에게 문의하십시오.',
      gatewayRegistrationFailed:
        '다시 시도하십시오. 다시 실패하면 시스템 관리자에게 문의하십시오.',
      doAssociationMessage:
        '게이트웨이 연결을 확인하고 게이트웨이 연결을 진행하십시오.',
      errorInAssociation: '연결을 처리하는 중 오류가 발생했습니다.',
      association: '연결',
      dataloseWarningForRegistration:
        '게이트웨이 등록이 진행 중이므로 몇 분 정도 걸릴 수 있습니다. 데이터 손실을 방지하기 위해 새로 고치지 마십시오.',
      dataloseWarningForAssociation:
        '게이트웨이 연결이 진행 중입니다. 몇 분 정도 걸릴 수 있습니다. 데이터 손실을 방지하기 위해 새로 고치지 마십시오.',
      objectName: '객체 이름',
      objectType: '객체 유형',
      unitName: '단위',
      bitunpack: '비트 압축 풀기',
      bitRange: '비트 범위',
      propName: '속성 이름',
      propDataType: '데이터 유형',
      propValue: '속성 값',
      msgType: '메시지 유형',
      isMultiState: '다중 상태',
      scalingOperation: '스케일링 작업',
      scalingFactor: '스케일링 팩터',
      byteOrder: '바이트 순서',
      propertyName: '속성 이름',
      addTemplateSuccess: '템플릿이 성공적으로 추가되었습니다',
      addTemplateError: '템플릿을 추가할 수 없습니다. 다시 시도하세요.',
      updateTemplateSuccess: '템플릿이 성공적으로 업데이트되었습니다',
      updateTemplateError:
        '템플릿을 업데이트할 수 없습니다. 다시 시도하십시오.',
      outOfRangeError: '값은 {{min}}에서 {{max}} 사이여야 합니다',
      requiredField: '모든 필드를 채우십시오',
      templateName: '템플릿 이름',
      modelName: '모델명',
      vendorName: '공급업체 이름',
      uniqueValueError: '값은 고유해야 합니다',
      templateMangement: '템플릿 관리',
      equipmentType: '장비 유형',
      selectType: '유형 선택',
      listOfTemplate: '템플릿 목록',
      selectTemplate: '템플릿 선택',
      ElectricityVoltage: '전기 전압',
      ElectricityCurrent: '전기 전류',
      ElectricPowerFactor: '전력 계수',
      ElectricFrequency: '전기 주파수',
      EnergyReceived: '받은 에너지',
      ActivePower: '유효 전력',
      ActivePowerA: '유효 전력 A',
      ActivePowerB: '유효 전력 B',
      ActivePowerC: '유효 전력 C',
      ReactivePower: '무효 전력',
      ApparentPower: '피상 전력',
      PeakDemand: '최대 수요',
      ElectricityCurrentA: '전기 전류 A',
      ElectricityCurrentB: '전기 전류 B',
      ElectricityCurrentC: '전기 전류 C',
      ElectricityVoltageA: '전기 전압 A',
      ElectricityVoltageB: '전기 전압 B',
      ElectricityVoltageC: '전기 전압 C',
      ElectricityConsumption: '전력 소비',
      loaderWelcomeMessage:
        '온보딩 포털에 오신 것을 환영합니다. 잠시만 기다려 주십시오.',
      latitudeAndLongitude: '위도 및 경도',
      siteUpdateSuccessMessage:
        '사이트 세부 정보가 성공적으로 업데이트되었습니다',
      siteUpdateErrorMessage: '사이트 세부 정보 업데이트 오류',
      provisioningFailedMessages:
        '사이트 프로비저닝에 실패했습니다. 다시 시도하십시오.',
      onboardAllSites: '모든 사이트 온보딩',
      geoCordinatesErrorMsg: '좌표를 확인하십시오.',
      tooltipCordinateMessage: '좌표는 다음 범위여야 합니다.',
      emptyValueMessage: '빈 값은 허용되지 않습니다',

      browseFile: '파일 찾아보기',
      fileTypeErrorMsg: '파일 형식이 허용되지 않습니다',

      orgImgTitle: '조직 로고 업로드',
      orgImgDropTxt: '로고 끌어다 놓기',
      orgImgInfoTxt: 'W {{width}}px X H {{height}}px 및 *.png 파일 형식만',
      orgImgPreviewTxt: '로고 미리 보기',
      orgImgTooltipTxt:
        '로고는 배경이 투명하고 검은색 헤더 배경과 대조되어야 합니다',
      orgImgSizeOfErrorMsg:
        '이미지 크기는 최대 너비 {{width}}px, 최대 높이 {{height}}px, 최소 너비 {{minWidth}}px, 최소 높이 {{minHeight}}px, 최대 크기 {{maxSize}}KB여야 합니다.',

      siteImgTitle: '사이트 이미지 업로드',
      siteImgDropTxt: '건물 이미지 끌어다 놓기(*.png 또는 .jpg)',
      siteImgPreviewTxt: '사이트 세부 정보 페이지 미리보기',
      siteTooltipTxt:
        '이미지는 다른 모니터 해상도에 따라 이미지의 오른쪽과 왼쪽에서 46px, 상단과 하단에서 30px이 잘립니다.',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px 및 *.png & *.jpg 파일 형식',
      siteImgSizeOfErrorMsg:
        '이미지 크기는 최대 너비 {{width}}px, 높이 {{height}}px, 크기 {{maxSize}}KB여야 합니다.',
      orTxt: '또는',
      addLogo: '로고 추가',
      addImage: '이미지 추가',
      imageUploadSuccess: '이미지가 성공적으로 업로드됨',
      alertnteId: '대체 사용자 이름: ',
      username: '사용자 이름: ',
      errorFetchingUser: '사용자 세부 정보를 가져오는 중 오류 발생',
      errorFetchingRoles: '역할을 가져오는 중 오류 발생',

      gateway: '게이트웨이',
      associateAndSyncBtn: '연결 및 동기화',
      cancelBtn: '취소',
      guidValidationError: 'GUID 유효성 검사 오류',
      gatewayId: '게이트웨이 ID',
      addNewGateway: '새 게이트웨이 추가',
      successMessage1: '사이트 연결 완료',
      successMessage2: '사이트 연결 완료. 모델 동기화가 시작됩니다.',
      errorMessage: '연결 실패, 모델 동기화가 시작되지 않습니다',
      importUsers: '사용자 가져오기',
      importUsersSubHeading:
        'CSV 템플릿을 다운로드하여 가져오려는 항목을 추가하고 관리할 수 있습니다.',
      dropCsvHere: '여기에 파일을 끌어다 놓거나',
      browsrForFiles: '파일 찾아보기',
      subHeadingBrowser:
        'CSV 파일만 허용되며, 파일은 5MB를 초과해서는 안 됩니다.',
      subHeadingBrowserTwo: '(한 번에 하나의 업로드만 가능)',
      userUploadSuccess: '성공적으로 데이터 보냄',
      userUploadProcessing:
        '데이터가 성공적으로 업로드되었습니다. 현재 처리 중이며 몇 분 정도 소요됩니다. 곧 업데이트를 보내드리겠습니다.',
      fileNameDisplay: '파일 이름 : ',
      fileName: '파일 이름',
      errorNotification:
        '템플릿을 업로드하는 동안 문제가 발생했습니다. 아래 오류를 수정하고 템플릿을 다시 업로드하십시오.',
      errorHeading: '오류',
      slnumber: '일련 번호',
      errorMessageHeading: '오류 메시지',
      endUserAgreement: 'Honeywell Forge 약관',
      privacyStatement: '개인 정보 보호 정책',
      yourPrivacyChoices: '귀하의 개인 정보 선택',
      cookieNotice: '쿠키 고지',
      dataCentre: '데이터 센터',
      isForgeText: '건물',
      gatewayIdleMessage:
        '몇 분 동안 유휴 상태였습니다. 계속하려면 페이지를 새로 고치십시오.',
      refresh: '새로고침',
      landingLogin: '여기를 클릭하세요',
      loginUserIntegratorRole: 'BA 전자상거래 사용자',
      loginUserCustomerRole: '다른 모든 사용자',
      loginWelcomeNote: '환영합니다. 시작하려면 아래에서 역할을 선택하십시오.',
      termsAndConditions: '이용 약관',
      accept: '수락',
      legalPatentInformation: '법률 특허 정보',
      onboardingPortal: '온보딩 포털',
      customers: '고객',
      templates: '템플릿',
      assetModelling: '자산 모델링',
      selectCustomer: '고객 선택',
      integration: '통합',
      integrationSubtitle: '실시간 성능 인사이트를 위한 원활한 통합',
      customer: '고객',
      accessibleCustomersError: '접근 가능한 고객 가져오기 오류',
      workflows: '레거시 워크플로우',
      apiCredentials: 'API 로그인 정보',
      integrationsTab: '워크플로',
      noSubscription:
        '유효한 구독이 없습니다. 이 기능을 이용하려면 구독해 주세요.',
      loading: '로드 중...',
      licenseManagement: '라이선스 관리',
      activityLogTitle: '활동 기록',
      activityLogSubtitle:
        '선택한 고객의 워크플로우 이벤트 및 상태 업데이트 추적',
      activityLogSidebarTitle: '활동 기록',
      activityLogSidebarSubtitle: '다음은 모든 고객 조직의 활동 데이터입니다.',
      activityLogListTitle: '활동 목록',
      activityLogSearchPlaceholder: '활동, 사이트별 검색',
      activityLogLastUpdated: '마지막 업데이트',
      activityLogCreatedOn: '생성 날짜',
      activityLogActivity: '활동',
      activityLogSite: '사이트',
      activityLogStatus: '상태',
      activityLogCreatedBy: '작성자',
      activityLogUpdatedBy: '업데이트 실행자',
      activityLogNameUnavailable: '이름을 사용할 수 없음',
      activityLogUserNamesError: '작성자 / 업데이트 실행자 이름 불러오기 실패',
      activityLogStatusSuccess: '성공',
      activityLogStatusFailed: '실패함',
      activityLogStatusInProgress: '진행 중',
      activityLogStatusQueued: '대기 중',
      activityLogStatusPending: '보류 중',
      activityLogStatusSkipped: '건너뛰었습니다',
      activityLogPaginationInfo: '{totalItems}개 항목 중 {startItem}~{endItem}',
      activityLogPageGoTo: '페이지로 이동',
      activityLogRowPerPage: '페이지별 행 수',
      activityLogRetry: '재시도',
      activityLogRetrying: '재시도 중...',
      activityLogRetrySuccess: '작업 재시도가 성공적으로 시작되었습니다.',
      activityLogRetryError: '작업 재시도 실패. 다시 시도해 주세요.',
      activityLogRetryAllSuccess: '모든 작업이 성공적으로 재시도되었습니다.',
      activityLogRetryAllFailed:
        '모든 재시도가 실패했습니다. 다시 시도해 주세요.',
      activityLogRetryPartialFailed:
        '일부 작업 재시도 실패. 다시 시도해 주세요.',
      activityLogLoading: '세부 정보 로딩 중...',
      activityLogFetchError: '활동 데이터 불러오기 실패. 다시 시도해 주세요.',
      activityLogModalClose: '닫기',
      activityLogModalTasks: '작업',
      activityLogModalCreatedOn: '생성 날짜',
      activityLogModalLastUpdatedOn: '마지막 업데이트 날짜:',
      activityLogModalSupportNote: '실패 이벤트와 사유 코드에 대한 설명.',
      activityLogModalSupportReach: '도움이 필요하시면',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: '필터링 기준',
      noCustomersAvailable: '고객 없음',
      activityLogFilterStatus: '상태',
      activityLogFilterActivity: '활동',
      activityLogFilterSite: '사이트',
      activityLogFilterCreatedBy: '작성자',
      activityLogFilterApply: '적용',
      activityLogFilterReset: '재설정',
      activityLogFilterNoOptions: '사용할 수 있는 옵션 없음',
      activityLogFilterError: '필터 옵션 불러오기 실패. 다시 시도해 주세요.',
      search: '검색',
      more: '추가',
      noResults: '검색된 결과 없음',
      activityLogCustomizeColumns: '열 사용자 정의',
      activityLogColumnsReorder: '재주문',
      activityLogColumnsAddRemove: '추가/제거',
      activityLogColumnsReorderDescription:
        '테이블의 열 순서를 변경하기 위해 다시 배치합니다.',
      activityLogColumnsAddRemoveDescription: '테이블에 표시할 열을 선택하세요',
      activityLogDetails: '세부 정보',
      activityLogFiltersChanged:
        '선택한 필터에 해당하는 데이터가 없습니다. 결과를 보려면 필터를 조정하거나 초기화하십시오.',
      activityLogResetFilters: '필터 재설정',
      activityLogSiteState: '상태',
      activityLogSiteCity: '도시',
      workflowTaskCBCustomerCreation: 'CB 고객 생성',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        '파트너 포털에서 온보딩 상태 업데이트',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        '파트너 포털에서 CB 고객 ID 업데이트',
      workflowTaskEOMCustomerCreation: 'EOM 고객 생성',
      workflowTaskOnboardCustomerForAI: 'AI를 위한 고객 온보딩',
      workflowTaskDeleteCustomerInCBPortal: 'CB 포털에서 고객 삭제',
      workflowTaskUpdateCustomerInCBPortal: 'CB 포털에서 고객 업데이트',
      workflowTaskUpdateCustomerInEOM: 'EOM에서 고객 업데이트',
      workflowTaskUpdateCustomerInAssetModelling:
        '자산 모델링에서 고객을 업데이트',
      workflowTaskTrackScanStatusFileAttachment: '첨부 파일의 스캔 상태 추적',
      workflowTaskCBSiteCreation: 'CB 사이트 생성',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        '파트너 포털에서 CB 사이트 ID 업데이트',
      workflowTaskEOMSiteCreation: 'EOM 사이트 생성',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        '파트너 포털에서 EOM 사이트 ID 업데이트',
      workflowTaskSyncExistingUsersCBPortal:
        '기존 사용자를 CB 포털에 동기화하기',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        '파트너 포털에서 사용자 동기화 상태 업데이트',
      workflowTaskCalculateEnergySavingsPotential: '가능한 에너지 절감액 계산',
      workflowTaskDeleteSiteInCBPortal: 'CB 포털에서 사이트 삭제',
      workflowTaskDeleteSiteInEOM: 'EOM에서 사이트 삭제',
      workflowTaskUpdateSiteInCBPortal: 'CB 포털에서 사이트 업데이트',
      workflowTaskUpdateSiteInEOM: 'EOM에서 사이트 업데이트',
      workflowTaskUpdateSiteInAssetModelling: '자산 모델링에서 사이트 업데이트',
      workflowTaskUpdateSiteInFindAPI: 'Find API에서 사이트 업데이트',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        '구독 연결을 CB 포털에 동기화',
      workflowTaskEnableBrickOntology: '브릭 온톨로지 사용',
      workflowTaskOnboardCustomerForgeAPI: '고객을 ForgeAPI에 온보딩',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'ForgeAPI 온보딩 상태를 Credential Management에 게시합니다',
      workflowTaskAddUserInCBPortal: 'CB 포털에서 사용자 추가',
      workflowTaskUpdateUserProvisioningStatus:
        '사용자 프로비저닝 상태 업데이트',
      workflowTaskDeleteUserInCBPortal: 'CB 포털에서 사용자 삭제',
      workflowTaskUpdateUserDeletionStatus: '사용자 삭제 상태 업데이트',
      workflowCustomerCreation: '고객 생성',
      workflowCustomerDelete: '고객 삭제',
      workflowCustomerUpdate: '고객 업데이트',
      workflowFileAttachmentsScan: '첨부 파일 스캔 상태',
      workflowSiteCreation: '사이트 생성',
      workflowSiteDelete: '사이트 삭제',
      workflowSiteUpdate: '사이트 업데이트',
      workflowSubscriptionAssociation: '구독 연결',
      workflowAddUser: '사용자 추가',
      workflowDeleteUser: '사용자 삭제',
      workflowNamePlate: '명판',
      workflowForgeAPIOnboarding: 'Forge API 온보딩',
      workflowAddUserMultiple: '여러 사용자 추가 워크플로',
      workflowDeleteUserMultiple: '여러 사용자 삭제 워크플로',
      workflowModelFileUpload: '모델 파일 업로드',
      workflowGatewayAssociation: '게이트웨이 연결',
      workflowIntegrationRegistered: '통합 등록됨',
      workflowTaskForgeAPIOnboardingStatus: 'Forgeapi 온보딩 상태',
      workflowTaskAddUser: '사용자 추가 워크플로',
      workflowTaskProcessModelFile: '프로세스 모델 파일',
      workflowTaskNotifyAssetModelling: '자산 모델링 알림',
      workflowTaskAssociateGateway: '게이트웨이 사이트에 연결',
      workflowTaskFetchModelToAssetModelling:
        '자산 모델링을 위해 모델 가져오기',
      workflowTaskNameProcessNamePlate: '명판 파일.',
      workflowTaskUpdateModelInFindAPI: 'Find API에서 모델 업데이트',
      workflowTaskProcessIntegrationRegistered: '프로세스 통합 등록됨',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'DF 통합 등록 알림 처리',
      workflowTaskTenantOnboardingAFO: 'AFO로 테넌트 온보딩',
      workflowTaskOnboardCustomerCDL: 'CDL를 위한 고객 온보딩',
      workflowTaskPublishAFOOnboardingStatus: 'Rule Builder 서비스에 AFO 온보딩 상태 게시',
      activityLogCorrelationId: '상관관계 ID',
      activityLogTaskId: '태스크 ID',
      activityLogToastSuccess: '성공',
      activityLogToastError: '오류',
      activityLogIteration: '반복',
      activityLogFieldFirstName: '이름',
      activityLogFieldLastName: '성',
      activityLogFieldSubscriptionName: '구독 이름',
      activityLogFieldName: '이름',
      activityLogFieldCurrency: '통화',
      activityLogFieldZip: '우편 번호',
      activityLogFieldArea: '영역',
      activityLogFieldCity: '도시',
      activityLogFieldState: '상태',
      activityLogFieldCountry: '국가',
      activityLogFieldAreaUnit: '건물 내 세부 주소',
      activityLogFieldLanguage: '언어',
      activityLogFieldLatitude: '위도',
      activityLogFieldSiteType: '사이트 유형',
      activityLogFieldTimezone: '시간대',
      activityLogFieldLongitude: '경도',
      activityLogFieldCountryCode: '국가 코드',
      activityLogFieldSiteId: '현장 ID',
      activityLogFieldFileType: '파일 형식',
      activityLogFieldReason: '사유',
      activityLogFieldCustomerSupportEmails: '고객 지원 이메일',
      activityLogFieldAddressLine1: '주소 줄 1',
      activityLogFieldAddressLine2: '주소 줄 2',
      activityLogFieldContactEmail: '연락처 이메일',
      activityLogSiTitle: '활동 로그',
      support: '지원',
      projectManagement: '프로젝트 관리',
    }
  }
};
